import { getTheme, loadTheme, ITheme } from '@fluentui/react';
import { ThemeDesigner } from './ThemeDesigner';

export enum SitemapOrientation {
    Horizontal = 742070000,
    Vertical = 742070001,
}

export class Theme {
    private _lightMain: ITheme;
    private _darkMain: ITheme;
    private _lightNavigation: ITheme;
    private _darkNavigation: ITheme;
    private _navbarTheme: ITheme;
    private _ribbonTheme: ITheme;
    private _dark = false;
    public sitemap = { orientation: SitemapOrientation.Vertical };

    private static _instance: Theme;

    public static get(): Theme {
        if (!Theme._instance) {
            Theme._instance = new Theme();
        }
        return Theme._instance;
    }

    constructor() {
        const baseTheme = getTheme();

        this._lightMain = ThemeDesigner.generateTheme({
            primaryColor: baseTheme.palette.themePrimary,
            backgroundColor: '#ffffff',
            textColor: '#323130',
        });

        this._darkMain = ThemeDesigner.generateTheme({
            primaryColor: '#4fc1ff',
            backgroundColor: '#252526',
            textColor: '#cccccc',
        });

        this._navbarTheme = ThemeDesigner.generateTheme({
            primaryColor: '#ffffff',
            backgroundColor: '#1f1f1f',
            textColor: '#ffffff',
        });

        this._ribbonTheme = ThemeDesigner.generateTheme({
            primaryColor: baseTheme.palette.themePrimary,
            backgroundColor: '#ffffff',
            textColor: '#323130',
        });

        this._lightNavigation = ThemeDesigner.generateTheme({
            primaryColor: baseTheme.palette.themePrimary,
            backgroundColor: '#ffffff',
            textColor: '#323130',
        });

        this._darkNavigation = ThemeDesigner.generateTheme({
            primaryColor: '#4fc1ff',
            backgroundColor: '#252526',
            textColor: '#cccccc',
        });

        loadTheme(this._lightMain);
    }

    public get isDark(): boolean { return this._dark; }

    public get main(): ITheme { return this._dark ? this._darkMain : this._lightMain; }
    public get navbar(): ITheme { return this._navbarTheme; }
    public get ribbon(): ITheme { return this._ribbonTheme; }
    public get navigation(): ITheme { return this._dark ? this._darkNavigation : this._lightNavigation; }

    public setDark(dark: boolean) {
        this._dark = dark;
        loadTheme(this.main);
        document.documentElement.setAttribute('data-theme', dark ? 'dark' : 'light');
    }
}
